import React, {
  useEffect,
  useState,
} from "react";

import styled from "@emotion/styled";

import {
  Link,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Pagination,
  Box,
  Badge,
  Typography,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  Grid,
  Divider,
  TextField,
  MenuItem,
  IconButton,
  Chip,
} from "@mui/material";

import FilterListIcon from "@mui/icons-material/FilterList";
import CancelIcon from "@mui/icons-material/Cancel";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";

import axios from "axios";

import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { paths } from "../../config/constants";
import { useSelector } from "react-redux";

import {
  useLocation,
  useNavigate,
} from "react-router-dom";

import logo from "../../Assets/Images/BLU TAXI logo.png";


const TableCellWraper = styled(TableCell)(() => ({
  textAlign: "left",
  fontWeight: 600,
  fontSize: "14px",
  color: "#000",
}));

const BodyTableCellWraper = styled(TableCell)(() => ({
  textAlign: "left",
  fontWeight: 500,
  fontSize: "14px",
  color: "#000",
}));

export default function CompanyAgentCommonReports() {

  const navigate = useNavigate();

  const location = useLocation();

  const reduxdata = useSelector(
    (state) => state
  );

  const userId =
    reduxdata?.login?.user?.data?._id;


  const [data, setData] = useState([]);

  const [filteredData, setFilteredData] =
    useState([]);

  const [employees, setEmployees] =
    useState([]);

  const [currentPage, setCurrentPage] =
    useState(1);

        const [searchText, setSearchText] = useState("");
    

  const [postsPerPage] = useState(10);
  const companyName=localStorage.getItem('companyName')
   const accountType = localStorage.getItem("accountType");

const reportTitle = (() => {
  switch (location.pathname) {
    case paths.company.companyReport:
      return "My Booking";

    case paths.company.customerReport:
      return "Customer";

    case paths.company.employeeReport:
      return "Employee";

    case paths.businessAgent.ReportsPage:
      return "Agent";

    default:
      return "";
  }
})();



const nameColumn =
  location.pathname === paths.company.employeeReport
    ? "Employee Name"
    : "Customer Name";

      const [open, setOpen] = useState(false);
      const [allData, setAllData] = useState([]);
      const [payType, setPayType] = useState();

  const [filterDialogOpen, setFilterDialogOpen] =
    useState(false);

const [filters, setFilters] = useState({
  searchBy: "",
  payment: "",
  status: "",
  type: "",
  employee: "",
});


   const toRoman = (num) => {
  const romanMap = [
    [1000, "M"],
    [900, "CM"],
    [500, "D"],
    [400, "CD"],
    [100, "C"],
    [90, "XC"],
    [50, "L"],
    [40, "XL"],
    [10, "X"],
    [9, "IX"],
    [5, "V"],
    [4, "IV"],
    [1, "I"],
  ];
  let result = "";
  for (const [value, symbol] of romanMap) {
    while (num >= value) {
      result += symbol;
      num -= value;
    }
  }
  return result;
};

  const [tempFilters, setTempFilters] =
    useState(filters);

  const [displayDateRange, setDisplayDateRange] =
    useState({
      fromDate: "",
      toDate: "",
    });

  const [tempDateRange, setTempDateRange] =
    useState({
      fromDate: "",
      toDate: "",
    });

  const totalPage = Math.ceil(
    filteredData.length / postsPerPage
  );

  const lastPostIndex =
    currentPage * postsPerPage;

  const firstPostIndex =
    lastPostIndex - postsPerPage;

  const currentPosts = filteredData.slice(
    firstPostIndex,
    lastPostIndex
  );

const getDefaultDateRange = () => {
  const now = new Date();

  // Start date (3 months ago) at 00:00:00.000 UTC
  const start = new Date(Date.UTC(
    now.getUTCFullYear(),
    now.getUTCMonth() - 3,
    now.getUTCDate(),
    0,
    0,
    0,
    0
  ));

  // End date (today) at 23:59:59.999 UTC
  const end = new Date(Date.UTC(
    now.getUTCFullYear(),
    now.getUTCMonth(),
    now.getUTCDate(),
    23,
    59,
    59,
    999
  ));

  return {
    journeyStart: start.getTime(),
    journeyEndDate: end.getTime(),
    fromDate: start.toISOString().split("T")[0],
    toDate: end.toISOString().split("T")[0],
  };
};


const fetchEmployeesList = async () => {
  try {
    const res = await axios.post(
        `${process.env.REACT_APP_URL}api/user/fetchEmployees`,
        {
          companyName: companyName,
        }
      );

    if (res?.data?.status === 200) {
      setEmployees(res?.data?.data || []);
    } else {
      setEmployees([]);
    }
  } catch (error) {
    console.log(error);
    setEmployees([]);
  }
};

  const fetchUserData = async (
    startTime,
    endTime,
    otherFilters = filters
  ) => {

    try {

      const reportTypeMap = {
  "My Booking": "Company",
  "Customer": "Customer",
  "Employee": "Employee",
  "Agent": "Agent",
};

      const payload = {
  userID: userId,

  journeyStart: startTime,

  journeyEndDate: endTime,

  search: searchText || "",

  searchBy: otherFilters.searchBy || "",

  payment: otherFilters.payment || "",

  status: otherFilters.status || "",

  type: otherFilters.type || "",

employeeId: otherFilters.employee || "",

 ...(reportTypeMap[reportTitle] && {
    reportType: reportTypeMap[reportTitle],
  }),
};

      const res = await axios.post(
        `${process.env.REACT_APP_URL}api/booking/getBusinessAgentBookingsFiltered`,
        payload
      );

      const sortedBookings =
        (res?.data?.data || []).sort(
          (a, b) => b.date - a.date
        );

      setData(sortedBookings);

      setFilteredData(sortedBookings);

    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {

    const defaultRange =
      getDefaultDateRange();

       const emptyFilters = {
    searchBy: "",
    payment: "",
    status: "",
    type: "",
    driver: "",
    vehicle: "",
  };

  // reset filters
  setFilters(emptyFilters);
  setTempFilters(emptyFilters);
  // setSearchText('');

  // reset pagination
  setCurrentPage(1);

    setDisplayDateRange({
      fromDate:
        defaultRange.fromDate,

      toDate:
        defaultRange.toDate,
    });

    setTempDateRange({
      fromDate:
        defaultRange.fromDate,

      toDate:
        defaultRange.toDate,
    });

      // clear existing data (optional but recommended)
  setData([]);
  setFilteredData([]);

    if (reportTitle === "My Booking" || reportTitle === "Employee") {
    fetchEmployeesList();
  }

    fetchUserData(
      defaultRange.journeyStart,
      defaultRange.journeyEndDate
    );

  }, [reportTitle]);



  useEffect(() => {
    const defaultRange = getDefaultDateRange();
  
    const timer = setTimeout(() => {
      fetchUserData(
        defaultRange.journeyStart,
        defaultRange.journeyEndDate,
        filters,
        searchText
      );
    }, 500);
  
    return () => clearTimeout(timer);
  }, [searchText, filters]);



const getStatusLabel = (curElem) => {
  // Highest priority: Cancelled/Refunded
  if (String(curElem?.status) === "6") {
    return "Cancelled/Refunded";
  }

  // Failed
  if (curElem?.failStatus === "Failed") {
    return "Failed";
  }

  // Cancelled
  if (curElem?.cancelStatus === "Cancelled") {
    return "Cancelled";
  }

  const statusMap = {
    "0": "Confirmed",
    "1": "Confirmed",
    "2": "Confirmed",
    "3": "Completed",
    "4": "No Show",
    "5": "On Spot Cancel",
  };

  return statusMap[String(curElem?.status)] || "";
};


const handleResetFilters = () => {
  const empty = {
    searchBy: "",
    payment: "",
    status: "",
    type: "",
    employee: "",
  };

  const defaultRange = getDefaultDateRange();

  setTempFilters(empty);

  setTempDateRange({
    fromDate: defaultRange.fromDate,
    toDate: defaultRange.toDate,
  });
};


const handleResetAll = () => {
  const empty = {
    searchBy: "",
    payment: "",
    status: "",
    type: "",
    employee: "",
  };

  const defaultRange = getDefaultDateRange();

  setFilters(empty);

  setTempFilters(empty);

  setDisplayDateRange({
    fromDate: defaultRange.fromDate,
    toDate: defaultRange.toDate,
  });

  setTempDateRange({
    fromDate: defaultRange.fromDate,
    toDate: defaultRange.toDate,
  });

  // ✅ IMPORTANT FIX
  fetchUserData(
    defaultRange.journeyStart,
    defaultRange.journeyEndDate,
    empty
  );

  // optional
  setCurrentPage(1);
};

  const handlePaginationClick = (
    event,
    page
  ) => {
    setCurrentPage(page);
  };

  const handleOpenFilterDialog = () => {

    setTempFilters(filters);

    setTempDateRange(displayDateRange);

    setFilterDialogOpen(true);
  };

  const handleCloseFilterDialog = () => {
    setFilterDialogOpen(false);
  };

  const handleTempInputChange = (e) => {

    setTempFilters({
      ...tempFilters,
      [e.target.name]: e.target.value,
    });
  };

  const handleTempDateChange = (e) => {

    const { name, value } = e.target;

    setTempDateRange({
      ...tempDateRange,
      [name]: value,
    });
  };

  const handleApplyFilters = () => {

    const from = new Date(tempDateRange.fromDate);
const to = new Date(tempDateRange.toDate);

const fromTimestamp = Date.UTC(
  from.getUTCFullYear(),
  from.getUTCMonth(),
  from.getUTCDate(),
  0,
  0,
  0,
  0
);

const toTimestamp = Date.UTC(
  to.getUTCFullYear(),
  to.getUTCMonth(),
  to.getUTCDate(),
  23,
  59,
  59,
  999
);


    setFilters(tempFilters);

    setDisplayDateRange(tempDateRange);

    fetchUserData(
      fromTimestamp,
      toTimestamp,
      tempFilters
    );

    setFilterDialogOpen(false);
  };


  const getActiveFilterCount = () => {
    return Object.values(filters).filter(Boolean)
      .length;
  };

const handleDownloadPDF = async () => {
  const doc = new jsPDF({
    orientation: "landscape",
    unit: "mm",
    format: "a4",
  });

  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  doc.setFont("helvetica", "normal");

  // =========================
  // RIGHT ALIGN HEADER BLOCK
  // =========================
  const drawRightAlignedBlock = (rows) => {
    doc.setFontSize(10);

    let maxWidth = 0;

    rows.forEach(({ label, value }) => {
      const width = doc.getTextWidth(`${label} ${value}`);
      if (width > maxWidth) maxWidth = width;
    });

    const startX = pageWidth - 14 - maxWidth;

    rows.forEach(({ label, value, y }) => {
      doc.setFont("helvetica", "bold");
      doc.text(label, startX, y);

      const labelWidth = doc.getTextWidth(label + " ");

      doc.setFont("helvetica", "normal");
      doc.text(value, startX + labelWidth, y);
    });
  };

  // =========================
  // IMAGE LOAD
  // =========================
  const loadImageAsBase64 = (url) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "Anonymous";

      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;

        canvas.getContext("2d").drawImage(img, 0, 0);
        resolve(canvas.toDataURL("image/png"));
      };

      img.onerror = reject;
      img.src = url;
    });
  };

  let logoBase64 = "";

  try {
    if (logo) {
      logoBase64 = await loadImageAsBase64(logo);
    }
  } catch (error) {
    console.error(error);
  }

  // =========================
  // HEADER
  // =========================
  const drawHeader = () => {
    if (logoBase64) {
      doc.addImage(logoBase64, "PNG", 14, 8, 42, 18);
    }

    drawRightAlignedBlock([
     {
  label: "Generated By:",
  value: reportTitle === "My Booking" ? "Company" : "Agent",
  y: 10,
},
      {
        label: "Generated On:",
        value: new Date().toLocaleDateString("en-GB"),
        y: 16,
      },
      {
        label: "Date Range:",
        value: `${
          displayDateRange?.fromDate
            ? new Date(displayDateRange.fromDate).toLocaleDateString("en-GB")
            : "-"
        } to ${
          displayDateRange?.toDate
            ? new Date(displayDateRange.toDate).toLocaleDateString("en-GB")
            : "-"
        }`,
        y: 22,
      },
    ]);

    doc.setLineWidth(0.5);
    doc.line(14, 30, pageWidth - 14, 30);
  };

  // =========================
  // FOOTER
  // =========================
  const drawFooter = () => {
    const y = pageHeight - 10;

    doc.setLineWidth(0.5);
    doc.line(14, y - 4, pageWidth - 14, y - 4);

    doc.setFontSize(9);

    doc.text(
      "FARZAPUR PLLC / Sofia 1309, Sofia Region Vazrazhdane District Tsaribrodska Street, No. 7, Workshop 7 / EIC/PIC: 208161477",
      pageWidth / 2,
      y,
      {
        align: "center",
        maxWidth: pageWidth - 30,
      }
    );
  };

  // =========================
  // FILTERS
  // =========================
  const getFiltersText = () => {
    let arr = [];

    if (filters?.searchBy) arr.push(`Search: ${filters.searchBy}`);
    if (filters?.payment) arr.push(`Payment: ${filters.payment}`);
    if (filters?.type) arr.push(`Type: ${filters.type}`);

    if (filters?.status) {
const map = {
  "Confirmed": "Confirmed",
  "3": "Completed",
  "4": "No Show",
  "5": "On Spot Cancel",
  "6": "Cancelled/Refunded",
  "cancelled": "Cancelled",
  "failed": "Failed",
};

  arr.push(`Status: ${map[filters.status] || "-"}`);
}

if (filters?.employee) {
  const emp = employees.find(
    (v) => v._id === filters.employee
  );

  if (emp) {
    arr.push(
      `Employee: ${emp.fName} ${emp.lName} (${emp.id})`
    );
  }
}

    return arr;
  };

  const filtersText = getFiltersText();
  const hasExtraFilters = filtersText.length > 0;

  // =========================
  // TABLE DATA
  // =========================
  const isEmpty = !filteredData || filteredData.length === 0;

  const tableData = isEmpty
  ? [
      [
        {
          content: hasExtraFilters
            ? "No Bookings Found for selected filters"
            : "No Bookings Found",
          colSpan: 12,
          styles: {
            halign: "center",
            fontStyle: "bold",
          },
        },
      ],
    ]
  : filteredData.map((b, index) => [
      filteredData.length - index,

      b.bookingId || "-",

      new Intl.DateTimeFormat("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
        timeZone: "UTC",
      }).format(Number(b?.date || 0)),

      `${b?.booking_contact_infos?.[0]?.fName || ""} ${
        b?.booking_contact_infos?.[0]?.lName || ""
      }`,

      b?.vehicaltypes?.[0]?.vehicalName || "-",

      b?.bookingType || "-",

       b?.status === "6"
  ? "Cancelled/Refunded"
  : b?.failStatus === "Failed"
  ? "Failed"
  : b?.cancelStatus === "Cancelled"
  ? "Cancelled"
  : ["0", "1", "2"].includes(String(b?.status))
  ? "Confirmed"
  : b?.status === "3"
  ? "Completed"
  : b?.status === "4"
  ? "No Show"
  : b?.status === "5"
  ? "On Spot Cancel"
  : "-",

         b?.createdAt
        ? new Date(b.createdAt).toLocaleString("en-GB", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
          })
        : "-",

      `${parseFloat(b?.total || 0).toFixed(2)} €`,

      b?.paymentType || "N/A",

      b?.reservationPdfUrl ? "Available" : "Not Available",

      b?.customerInvoiceURL ? "Available" : "Not Available",
    ]);

  // =========================
  // TITLE
  // =========================
  let startY = 38; // extra gap below header line

  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);

doc.text(`${reportTitle} Report`, pageWidth / 2, startY, {
  align: "center",
});

  startY += 10;

  // =========================
  // FILTER TAGS
  // =========================
  if (filtersText.length > 0) {
    doc.setFont("helvetica", "bold");
    doc.setFontSize(11);
    doc.text("Filters Applied:", 14, startY);

    startY += 6;

    let x = 14;
    let y = startY;

    const gap = 3;
    const paddingX = 3;
    const boxHeight = 6;
    const maxWidth = pageWidth - 14;

    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);

    filtersText.forEach((text) => {
      const textWidth = doc.getTextWidth(text);
      const boxWidth = textWidth + paddingX * 2;

      if (x + boxWidth > maxWidth) {
        x = 14;
        y += boxHeight + gap;
      }

      doc.setFillColor(0, 70, 127);
      doc.roundedRect(x, y, boxWidth, boxHeight, 2, 2, "F");

      doc.setTextColor(255, 255, 255);
      doc.text(text, x + paddingX, y + 4);

      doc.setTextColor(0, 0, 0);

      x += boxWidth + gap;
    });

    startY = y + 10;
  }

  // =========================
  // TABLE
  // =========================
  autoTable(doc, {
    head: [
      [
        "Sr. No.",
        "Booking ID",
        "Pickup Date & Time",
        location.pathname === paths.company.employeeReport
      ? "Employee Name"
      : "Customer Name",
        "Vehicle",
        "Type",
        "Status",
        "B.Date & Time",
        "Fare",
         "Payment",
      ],
    ],

    body: tableData,

    startY,

   margin: {
  top: 34,
  bottom: 18,
  left: 14,
  right: 14,
},

    styles: {
      fontSize: 7,
      cellPadding: 1.5,
      overflow: "linebreak",
      halign: "center",
      valign: "middle",
    },

    headStyles: {
      fillColor: [0, 70, 127],
      textColor: [255, 255, 255],
      fontSize: 7,
      fontStyle: "bold",
    },

    columnStyles: {
      0: { cellWidth: 11 },
      1: { cellWidth: 25 },
      2: { cellWidth: 31 },
      3: { cellWidth: 31 },
      4: { cellWidth: 31 },
      5: { cellWidth: 30 },
      6: { cellWidth: 30 },
      7: { cellWidth: 30 },
      8: { cellWidth: 30 },
      9: { cellWidth: 19 },
    },

    didDrawPage: () => {
      drawHeader();
      drawFooter();
    },
  });

doc.save(
  `${`${reportTitle} Report`.toLowerCase().replace(/\s+/g, "_")}.pdf`
);
};


  const isDefaultDateRange = () => {
  const defaultRange = getDefaultDateRange();

  return (
    displayDateRange.fromDate === defaultRange.fromDate &&
    displayDateRange.toDate === defaultRange.toDate
  );
};


const handleEmployeeChange = (e) => {
  setTempFilters({
    ...tempFilters,
    employee: e.target.value,
  });
};


    const fetchBookingDetails = async (bookingId) => {
      let data = {
        bookingId: bookingId,
      };
      setOpen(true);
      try {
        const res = await axios.post(
          `${process.env.REACT_APP_URL}api/booking/getbookingdetailsbyID`,
          data
        );
        const result = res?.data?.data || [];
      setAllData(result);
      setPayType(res);
      return result; // return data for use
      } catch (error) {
        console.log(error);
      }
    };


  return (
  <>
    <div
      className="row container-fluid bg-white justify-content-center"
      style={{
        paddingLeft: "0px",
        paddingRight: "0px",
      }}
    >

      <div
        className="col-md-11"
        style={{ padding: 0 }}
      >

       <Box
  sx={{
    mt: 4,
    mb: 3,
    mx: {
      xs: 2, // margin-left & margin-right on mobile
      md: 0,
    },
    display: "flex",
    justifyContent: "space-between",
    alignItems: {
      xs: "stretch",
      md: "center",
    },
    flexDirection: {
      xs: "column",
      md: "row",
    },
    gap: 2,
  }}
>

        <div className="HeadingCenter">
  <h3 className="admin-booking">
    {`${reportTitle} Report`}
  </h3>
</div>

         <Box
  sx={{
    display: "flex",
    gap: 1,
    flexWrap: "wrap",
    justifyContent: {
      xs: "stretch",
      sm: "flex-end",
    },
    width: {
      xs: "100%",
      md: "auto",
    },
  }}
>

            <Button
              variant="contained"
              color="success"
              startIcon={
                <InsertDriveFileIcon />
              }
              sx={{
  width: {
    xs: "100%",
    sm: "auto",
  },
  flex: {
    xs: "1 1 100%",
    sm: "1 1 30%",
    md: "0 0 auto",
  },
  minHeight: 40,
}}
              onClick={handleDownloadPDF}
            >
              Download PDF
            </Button>

                <Box
              sx={{
                flex: {
                  xs: "1 1 100%",
                  sm: "1 1 30%",
                  md: "0 0 auto",
                },
                width: {
                  xs: "100%",
                  sm: "auto",
                },
              }}
            >

            <Badge
              badgeContent={
                getActiveFilterCount()
              }
              color="primary"
              invisible={
                getActiveFilterCount() === 0
              }
               sx={{ width: "100%" }}
            >
              <Button
                variant="contained"
                startIcon={
                  <FilterListIcon />
                }
                fullWidth
                onClick={
                  handleOpenFilterDialog
                }
                sx={{ minHeight: 40 }}
              >
                Filters
              </Button>
            </Badge>
            </Box>

            <Button
              variant="outlined"
              onClick={handleResetAll}
              sx={{
  width: {
    xs: "100%",
    sm: "auto",
  },
  flex: {
    xs: "1 1 100%",
    sm: "1 1 30%",
    md: "0 0 auto",
  },
  minHeight: 40,
}}
            >
              Reset
            </Button>

          </Box>

        </Box>

<Box
  sx={{
    mb: 2,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 2,
  }}
>
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      flexWrap: "wrap",
      gap: 1,
      flex: 1,
      minWidth: 250,
    }}
  >
    <Typography variant="body2" color="text.secondary">
      Showing rides from:
    </Typography>

    <span className="badge bg-dark">
      {displayDateRange.fromDate &&
        new Date(displayDateRange.fromDate).toLocaleDateString("en-GB")}
      {" - "}
      {displayDateRange.toDate &&
        new Date(displayDateRange.toDate).toLocaleDateString("en-GB")}
    </span>

    {isDefaultDateRange() && (
      <Typography variant="caption" color="text.secondary">
        (Last 3 months by default)
      </Typography>
    )}
  </Box>

  <TextField
    size="small"
    label="Search"
    placeholder="Booking ID, Customer, Vehicle..."
    value={searchText}
    onChange={(e) => setSearchText(e.target.value)}
    sx={{
      width: {
        xs: "100%",
        sm: 300,
        md: 350,
      },
    }}
  />
</Box>

                    {getActiveFilterCount() > 0 && (
  <Box
    sx={{
      mb: 2,
      display: 'flex',
      gap: 1,
      flexWrap: 'wrap',
      alignItems: 'center',
    }}
  >
    <Typography variant="body2" color="text.secondary">
      Active Filters:
    </Typography>

    {filters?.searchBy && (
      <span className="badge custom-badge">
        Search: {filters.searchBy}
      </span>
    )}

    {filters?.payment && (
      <span className="badge custom-badge">
        Payment: {filters.payment}
      </span>
    )}

    {filters?.type && (
      <span className="badge custom-badge">
        Type: {filters.type}
      </span>
    )}

    {filters?.status && (
      <span className="badge custom-badge">
  Status: {{
      "Confirmed": "Confirmed",
    "3": "Completed",
    "4": "No Show",
    "5": "On Spot Cancel",
    "6": "Cancelled/Refunded",
    "cancelled": "Cancelled",
    "failed": "Failed",
  }[filters.status] || "-"}
</span>
    )}


{filters?.employee &&
  (() => {
    const emp = employees.find(
  (v) => v._id === filters.employee
);

    return emp ? (
      <span className="badge custom-badge">
        Employee: {emp.fName} {emp.lName} ({emp.id})
      </span>
    ) : null;
  })()}
  </Box>
)}

        <TableContainer>

          <Table>

            <TableHead
              style={{
                backgroundColor: "#FBFAFA",
              }}
            >

              <TableRow>

                <TableCellWraper>
                  Sr. No.
                </TableCellWraper>

                <TableCellWraper>
                  Booking ID
                </TableCellWraper>

                <TableCellWraper>
                  Pickup Date & Time
                </TableCellWraper>

               <TableCellWraper>
  {nameColumn}
</TableCellWraper>

                <TableCellWraper>
                  Vehicle
                </TableCellWraper>

                <TableCellWraper>
                 Type
                </TableCellWraper>

                <TableCellWraper>
                 Status
                </TableCellWraper>

                <TableCellWraper>
                  B.Date & Time
                </TableCellWraper>

                 <TableCellWraper>
                  Fare
                </TableCellWraper>

                <TableCellWraper>
                 Payment
                </TableCellWraper>

                <TableCellWraper>
                 Reservation PDF
                </TableCellWraper>

                <TableCellWraper>
                  Invoice PDF
                </TableCellWraper>

              </TableRow>

            </TableHead>

            <TableBody>

              {currentPosts?.length > 0 ? (

                currentPosts.map(
                  (curElem, i) => {

                    const serialNumber =
                      filteredData.length -
                      ((currentPage - 1) *
                        postsPerPage +
                        i);

                    return (

                      <TableRow
                        key={i}
                       
                      >

                        <BodyTableCellWraper>
                          {serialNumber}
                        </BodyTableCellWraper>

                        <BodyTableCellWraper
                                                                                                   component="th"
                                                                                                   scope="row"
                                                                                                   onClick={(e) => fetchBookingDetails(curElem?._id)}
                                                                                                 >
                                                                                                   <Link
                                                                                                     to=""
                                                                                                     className=" text-nowrap"
                                                                                                     style={{ color: "#0072CB", cursor:"pointer" }}
                                                                                                   >
                                                                                                     {curElem.bookingId}
                                                                                                   </Link>
                                                                                                 </BodyTableCellWraper>

                        <BodyTableCellWraper>
                           {new Intl.DateTimeFormat(
                            "en-GB",
                            {
                              day: "2-digit",
                              month: "2-digit",
                              year: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: false,
                              timeZone: 'UTC'
                            }
                          ).format(
                            parseInt(
                              curElem?.date
                            )
                          )}
                        </BodyTableCellWraper>


                        

                        <BodyTableCellWraper>
                          
                             {`${curElem?.booking_contact_infos?.[0]?.fName || ""} ${curElem?.booking_contact_infos?.[0]?.lName || ""}`}
                          
                        </BodyTableCellWraper>

                        <BodyTableCellWraper>
                          {curElem.vehicaltypes[0]?.vehicalName}
                        </BodyTableCellWraper>


<BodyTableCellWraper>
  {curElem.bookingType}
</BodyTableCellWraper>


                        <BodyTableCellWraper>
                          {getStatusLabel(curElem)}
                        </BodyTableCellWraper>

                         <BodyTableCellWraper>
  {new Date(curElem?.createdAt).toLocaleString("en-GB", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
                hour12: false,
              })}
</BodyTableCellWraper>

                      <BodyTableCellWraper>
  {parseFloat(curElem?.total).toFixed(2)} €
</BodyTableCellWraper>

<BodyTableCellWraper>
  {curElem?.paymentType || "N/A"}
</BodyTableCellWraper>

<BodyTableCellWraper>
  {curElem?.reservationPdfUrl ? (
    <a
      href={curElem?.reservationPdfUrl}
      download
      target="_blank"
      rel="noopener noreferrer"
    >
      <InsertDriveFileIcon
        style={{
          cursor: "pointer",
          color: "#0b2d48",
        }}
      />
    </a>
  ) : (
    <span>Not Available</span>
  )}
</BodyTableCellWraper>

<BodyTableCellWraper>
  {curElem?.customerInvoiceURL ? (
    <a
      href={curElem?.customerInvoiceURL}
      download
      target="_blank"
      rel="noopener noreferrer"
    >
      <InsertDriveFileIcon
        style={{
          cursor: "pointer",
          color: "#0b2d48",
        }}
      />
    </a>
  ) : (
    <span>Not Available</span>
  )}
</BodyTableCellWraper>

                      </TableRow>
                    );
                  }
                )

              ) : (

                <TableRow>
                  <TableCell
                    colSpan={12}
                    align="center"
                  >
                    No Data Found
                  </TableCell>
                </TableRow>

              )}

            </TableBody>

          </Table>

        </TableContainer>

        <div className="w-100 d-flex justify-content-end mt-4 mb-2">

          <Pagination
            count={totalPage || 1}
            page={currentPage}
            onChange={handlePaginationClick}
            color="primary"
          />

        </div>

      </div>

    </div>

     <Dialog
                open={filterDialogOpen}
                onClose={handleCloseFilterDialog}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle>
                    <Box display="flex" alignItems="center" justifyContent="space-between">
                        <Typography variant="h6" component="div">
                            <FilterListIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
                            Filter Rides
                        </Typography>
                        <IconButton onClick={handleCloseFilterDialog} size="small">
                            <CancelIcon />
                        </IconButton>
                    </Box>
                </DialogTitle>
                <Divider />
                <DialogContent>
                    <Grid container spacing={2} className="mb-3">
                        {/* Date Range - First Row */}
                        <Grid item xs={12} sm={6} md={6}>
                            <TextField
                                fullWidth
                                size="small"
                                type="date"
                                label="From Date"
                                InputLabelProps={{ shrink: true }}
                                name="fromDate"
                                value={tempDateRange.fromDate}
                                onChange={handleTempDateChange}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={6}>
                           <TextField
  fullWidth
  size="small"
  type="date"
  label="To Date"
  InputLabelProps={{ shrink: true }}
  name="toDate"
  value={tempDateRange.toDate}
  onChange={handleTempDateChange}
  inputProps={{
    min: tempDateRange.fromDate || undefined, // ✅ prevents earlier dates
  }}
/>
                        </Grid>

                        <Grid item xs={12}>
                            <Divider sx={{ my: 1 }} />
                        </Grid>

                        {/* Search By */}
                        <Grid item xs={12} sm={6} md={4}>
                            <TextField
                                select
                                fullWidth
                                size="small"
                                label="Search by"
                                name="searchBy"
                                value={tempFilters.searchBy}
                                onChange={handleTempInputChange}
                            >
                                <MenuItem value="" disabled>Search by...</MenuItem>
                                <MenuItem value="Booking Date">Booking Date</MenuItem>
                                <MenuItem value="Ride Date">Ride Date</MenuItem>
                            </TextField>
                        </Grid>

                        {/* Payment */}
                        <Grid item xs={12} sm={6} md={4}>
                            <TextField
                                select
                                fullWidth
                                size="small"
                                label="Payment Type"
                                name="payment"
                                value={tempFilters.payment}
                                onChange={handleTempInputChange}
                            >
                                <MenuItem value="">All</MenuItem>
                                <MenuItem value="Cash">Cash</MenuItem>
                                <MenuItem value="Card">Card</MenuItem>
                                <MenuItem value="Bank Invoice">Bank Invoice</MenuItem>
                            </TextField>
                        </Grid>

                        {/* Status */}
                       <Grid item xs={12} sm={6} md={4}>
  <TextField
    select
    fullWidth
    size="small"
    label="Status Type"
    name="status"
    value={tempFilters.status}
    onChange={handleTempInputChange}
  >
    <MenuItem value="">All</MenuItem>

    <MenuItem value="Confirmed">Confirmed</MenuItem>

    <MenuItem value="3">Completed</MenuItem>

    <MenuItem value="4">No Show</MenuItem>

    <MenuItem value="5">On Spot Cancel</MenuItem>

    <MenuItem value="6">Cancelled/Refunded</MenuItem>

    <MenuItem value="cancelled">Cancelled</MenuItem>

    <MenuItem value="failed">Failed</MenuItem>
  </TextField>
</Grid>

                        {/* Type */}
                        <Grid item xs={12} sm={6} md={4}>
                            <TextField
                                select
                                fullWidth
                                size="small"
                                label="Ride Type"
                                name="type"
                                value={tempFilters.type}
                                onChange={handleTempInputChange}
                            >
                                <MenuItem value="">All</MenuItem>
                                <MenuItem value="One Way">One Way</MenuItem>
                                <MenuItem value="Return Way">Return Way</MenuItem>
                            </TextField>
                        </Grid>

                         {accountType === "Company" &&
  (reportTitle === "Employee") && (
    <Grid item xs={12} sm={6} md={4}>
      <TextField
        select
        fullWidth
        size="small"
        label="Employee"
        name="employee"
        value={tempFilters.employee || ""}
        onChange={handleEmployeeChange}
      >
        <MenuItem disabled value="">
          Select Employee
        </MenuItem>

        {employees?.map((employee) => (
          <MenuItem key={employee._id} value={employee._id}>
            {employee.fName} {employee.lName} ({employee.id})
          </MenuItem>
        ))}
      </TextField>
    </Grid>
)}

                    
                    </Grid>

                    {/* Preview of selected filters */}
                    <Box sx={{
                        bgcolor: 'grey.50',
                        p: 2,
                        borderRadius: 1,
                        border: '1px dashed',
                        borderColor: 'grey.300'
                    }}>
                        <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 0.5 }}>
                            Selected Filters Preview:
                        </Typography>
                      <Typography variant="body2">
  <strong>Date Range:</strong>{" "}
  {tempDateRange.fromDate
    ? new Date(tempDateRange.fromDate).toLocaleDateString("en-GB")
    : "No Starting Date Selected"}{" "}
  to{" "}
  {tempDateRange.toDate
    ? new Date(tempDateRange.toDate).toLocaleDateString("en-GB")
    : "No Ending Date Selected"}

  <br />

  <strong>Other Filters:</strong>{" "}
  {[
    tempFilters.searchBy && `Search By: ${tempFilters.searchBy}`,
    tempFilters.payment && `Payment: ${tempFilters.payment}`,
  tempFilters.status &&
  `Status: ${
    {
       "Confirmed": "Confirmed",
      "3": "Completed",
      "4": "No Show",
      "5": "On Spot Cancel",
      "6": "Cancelled/Refunded",
      "cancelled": "Cancelled",
      "failed": "Failed",
    }[tempFilters.status] || "-"
  }`,
    tempFilters.type && `Type: ${tempFilters.type}`,


tempFilters.employee &&
(() => {
  const emp = employees.find(
    (v) => v._id === tempFilters.employee
  );

  return emp
    ? `Employee: ${emp.fName} ${emp.lName} (${emp.id})`
    : null;
})(),


  ]
    .filter(Boolean)
    .join(", ") || "None"}
</Typography>
                    </Box>
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 2 }}>
                    <Button
                        onClick={handleResetFilters}
                        color="inherit"
                        variant="outlined"
                        size="small"
                    >
                        Clear All
                    </Button>
                    <Box sx={{ flex: 1 }} />
                    <Button
                        onClick={handleCloseFilterDialog}
                        color="inherit"
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={handleApplyFilters}
                        variant="contained"
                        color="primary"
                        disabled={!tempDateRange.fromDate || !tempDateRange.toDate}
                    >
                        Apply Filters
                    </Button>
                </DialogActions>
            </Dialog>


                <Dialog
                               open={open}
                               onClose={() => setOpen(false)}
                               fullWidth
                               maxWidth={false}
                           >
                               <DialogTitle
                                   id="responsive-dialog-title"
                                   className="d-flex justify-content-between align-items-center ride-color p-2 m-0"
                               >
                                   {allData.map((allData, index) => {
                                       const getValue = (val) => {
                                           return val === null || val === undefined || val === "" ? "N/A" : val;
                                       };
               
                 const getStatus = (allData) => {
  // Highest priority: Cancelled/Refunded
  if (String(allData?.status) === "6") {
    return "Cancelled/Refunded";
  }

  // Failed
  if (allData?.failStatus === "Failed") {
    return "Failed";
  }

  // Cancelled
  if (allData?.cancelStatus === "Cancelled") {
    return "Cancelled";
  }

  const statusMap = {
    "0": "Confirmed",
    "1": "Confirmed",
    "2": "Confirmed",
    "3": "Completed",
    "4": "No Show",
    "5": "On Spot Cancel",
  };

  return statusMap[String(allData?.status)] || "";
};
               
                                       
               
                                       return (
                                           <div key={index} className="d-flex w-100 align-items-center text-center">
                                               <div className="text-white fw-bold" style={{ flex: 1 }}>
                                                   ID: {getValue(allData.bookingId)}
                                               </div>
                                               <div className="text-white fw-bold" style={{ flex: 1 }}>
                                                   Driver: {getValue(allData.driverName)}
                                               </div>
                                            <div className="text-white fw-bold" style={{ flex: 1 }}>
              Vehicle: {getValue(allData.vehicalCategoryName)} ({getValue(allData.vehicalNumber)})
            </div>
                                               <div className="text-white fw-bold" style={{ flex: 1 }}>
                                                    Status: {getStatus(allData)}
                                               </div>
                                           </div>
                                       );
                                   })}
               
                                   <div>
                                       <IconButton aria-label="delete" onClick={() => setOpen(false)}>
                                           <CancelIcon color="error" />
                                       </IconButton>
                                   </div>
                               </DialogTitle>
                               <DialogContent className="p-1">
                                   {allData.map((allData) => {
                                       return (
                                           <React.Fragment key={allData._id || Math.random()}>
                                               {allData.booking_contact_infos.map((data) => {
                                                   return (
                                                       <div className="border-top" key={data._id || Math.random()}>
                                                           <div className="ride-color text-white fw-bold py-1 ps-4">
                                                               <span>Customer Details</span>
                                                           </div>
                                                           <div className="row">
                                                               <div className="col-4 border nextLine">
                                                                   <div className="fw-bold">Name</div>
                                                                   <div>
                                                                       {data.fName}&nbsp;{data?.lName}
                                                                   </div>
                                                               </div>
                                                               <div className="col-4 border nextLine">
                                                                   <div className="fw-bold">Email</div>
                                                                   <div>{data?.email}</div>
                                                               </div>
                                                               <div className="col-4 border nextLine">
                                                                   <div className="fw-bold">Phone</div>
                                                                   <div>{data?.phoneNumber}</div>
                                                               </div>
                                                           </div>
                                                       </div>
                                                   );
                                               })}
                                               <div className="border-top">
                                                   <div className="ride-color text-white fw-bold  py-1 ps-4">
                                                       <span>Ride Details</span>
                                                   </div>
                                                   <div className="row">
                                                       <div className="col-12 border nextLine">
                                                           <div className="fw-bold">Ride Date & Time</div>
                                                           <div>
                                                               {new Intl.DateTimeFormat("en-GB", {
                                                                   day: "2-digit",
                                                                   month: "2-digit",
                                                                   year: "numeric",
                                                                   hour: "2-digit",
                                                                   minute: "2-digit",
                                                                   hour12: false,
                                                                   timeZone: "UTC",
                                                               }).format(parseInt(allData?.date))}
                                                           </div>
                                                       </div>
                                                   </div>
                                               </div>
               
                                               <div className="border-top">
                                                   <div className="row">
                                                       <div className="col-6 border-end nextLine">
                                                           <div className="ps-5">
                                                               <div>
                                                                   <b>Route</b>
                                                               </div>
                                                               <b>Pick up: </b>
                                                               <p className="">{allData?.fromLocation}</p>
                                                               <b>Drop off: </b>
                                                               <p>{allData?.toLocation}</p>
                                                           </div>
                                                       </div>
                                                       <div className="col-6" style={{ padding: 0 }}>
                                                           <div className="row">
                                                               {allData.vehicaltypes.map((item) => {
                                                                   return (
                                                                       <div className="col-6 border nextLine" key={item._id || Math.random()}>
                                                                           <div className="fw-bold">Vehical type</div>
                                                                           <div>{item.vehicalStandard}</div>
                                                                       </div>
                                                                   );
                                                               })}
                                                               <div className="col-6 border nextLine">
                                                                   <div className="fw-bold">Distance</div>
                                                                   <div>{allData?.distance} KM</div>
                                                               </div>
                                                               <div className="col-6 border nextLine">
                                                                   <div className="fw-bold">Duration</div>
                                                                   <div>{allData?.time}</div>
                                                               </div>
                                                               <div className="col-6 border nextLine">
                                                                   <div className="fw-bold">Flight No</div>
                                                                   <div>
                                                                       {allData?.flightNumber ? (
                                                                           <div>{allData.flightNumber}</div>
                                                                       ) : (
                                                                           <div>N/A</div>
                                                                       )}
                                                                   </div>
                                                               </div>
                                                               <div className="col-6 border nextLine">
                                                                   <div className="fw-bold">Extra Time</div>
                                                                   <div>{allData?.extraTime}</div>
                                                               </div>
                                                               <div className="col-6 border nextLine">
                                                                   <div className="fw-bold">WhatsApp</div>
                                                                   <div>
                                                                       {allData?.booking_contact_infos[0]?.whatsAppCheck
                                                                           ? "Checked"
                                                                           : "Unchecked"}
                                                                   </div>
                                                               </div>
                                                         <div className="col border nextLine">
              <div className="fw-bold">Customer Invoice</div>
            
              {allData?.cancelStatus === "Cancelled" ? (
                <span>Ride Canceled</span>
              ) : allData?.customerInvoiceURL ? (
                <div>
                  <a
                    href={allData.customerInvoiceURL}
                    download
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <InsertDriveFileIcon
                      style={{ cursor: "pointer", color: "#0b2d48" }}
                    />
                  </a>
                </div>
              ) : (
                <span>Yet to Complete</span>
              )}
            </div>
            
            <div className="col border nextLine">
              <div className="fw-bold">Reservation PDF</div>
            
              {allData?.cancelStatus === "Cancelled" ? (
                <span>Ride Canceled</span>
              ) : allData?.reservationPdfUrl ? (
                <div>
                  <a
                    href={allData.reservationPdfUrl}
                    download
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <InsertDriveFileIcon
                      style={{ cursor: "pointer", color: "#0b2d48" }}
                    />
                  </a>
                </div>
              ) : (
                <span>N/A</span>
              )}
            </div>
                                                           </div>
                                                       </div>
                                                       {allData.booking_contact_infos.map((data) => {
                                                           return (
                                                               <div className="col-12 border nextLine" key={data._id || Math.random()}>
                                                                   <div className="fw-bold">Comments</div>
                                                                   <div
                                                                       style={{
                                                                           wordWrap: "break-word",
                                                                           overflowWrap: "break-word",
                                                                           whiteSpace: "normal",
                                                                       }}
                                                                   >
                                                                       {data?.typeAnything}
                                                                   </div>
                                                               </div>
                                                           );
                                                       })}
                                                   </div>
                                               </div>
               
                                               <div className="border-top">
                                                   <div className="ride-color text-white fw-bold py-1 ps-4">
                                                       <span>Booking Extra Options</span>
                                                   </div>
                                                   <div className="row">
                                                       {allData?.booking_extra_services?.length > 0 ? (
                                                           allData?.booking_extra_services.map(
                                                               (service, index) => {
                                                                   const matchedOption = allData?.getExtraOption?.find(
                                                                       (option) => option._id === service.serviceId
                                                                   );
               
                                                                   return matchedOption ? (
                                                                       <div
                                                                           className="col-12 border nextLine"
                                                                           key={matchedOption._id}
                                                                       >
                                                                           <div className="row py-1">
                                                                               <div className="col-2 fw-bold">
                                                                                   {toRoman(index + 1)}:
                                                                               </div>
                                                                               <div className="col-4">
                                                                                   <b>{service?.number}</b>&nbsp;<b>X</b>&nbsp;
                                                                                   <b>{matchedOption?.type}</b>&nbsp;
                                                                                   {matchedOption?.desc}
                                                                               </div>
                                                                           </div>
                                                                       </div>
                                                                   ) : (
                                                                       <div
                                                                           className="col-12 border nextLine"
                                                                           key={service._id}
                                                                       >
                                                                           <div className="row py-1">
                                                                               <div className="col-12 text-danger">
                                                                                   No matching extra option found
                                                                               </div>
                                                                           </div>
                                                                       </div>
                                                                   );
                                                               }
                                                           )
                                                       ) : (
                                                           <div className="col-12 text-muted text-center py-2">
                                                               No extra options selected
                                                           </div>
                                                       )}
                                                   </div>
                                               </div>
               
                                               <div className="border-top">
                                                   <div className="ride-color text-white fw-bold  py-1 ps-4">
                                                       <span>Ride Fare</span>
                                                   </div>
                                                   <div className="row">
                                                       <div className="col-6 border-end nextLine">
                                                           <div className="fw-bold">Total Fare</div>
                                                           <div>{allData?.total} €</div>
                                                       </div>
                                                       <div className="col-6 border-end nextLine">
                                                           <div className="fw-bold">Payment Type</div>
                                                           <div>{payType?.data?.data[0]?.paymentType}</div>
                                                       </div>
                                                   </div>
                                               </div>
                                           </React.Fragment>
                                       );
                                   })}
                               </DialogContent>
                           </Dialog>

  </>
);}